import React from "react";
import { LoadingSpinner } from "@cmp-src/loadings/LoadingSpinner";
import { Button } from "@cmp-src/primitives/button";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

export const ReserveFormActions: React.FC = () => {
  const { isSubmitDisabled, isLoading, schedule } = useReserveForm();
  return (
    <Button
      type="submit"
      className="w-full font-bold"
      disabled={isSubmitDisabled}
      isLoading={isLoading}
    >
      {schedule ? "Edit Reservation" : "Reserve"}
    </Button>
  );
};
